// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teacher-performance-section {
  width: 1000px;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 0;
  margin-bottom: 0;
  position: relative;
  transition: width 0.3s ease;
}

/* Стили для расширенного режима */
.teacher-performance-section.expanded {
  width: 1200px !important;
}

/* Стили когда меню свернуто */
body.menu-collapsed .teacher-performance-section {
  width: 1200px !important;
}

/* Заголовок */
.performance-header {
  margin-bottom: 24px;
  padding: 0 8px;
  width: 100%;
}

.performance-title-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.performance-title {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
}

.group-title {
  font-size: 24px;
  font-weight: 600;
  color: #002FA7;
  margin: 0;
}

.subject-full-title {
  font-size: 16px;
  color: #64748b;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  white-space: normal;
  word-wrap: break-word;
  max-width: 600px;
}

.performance-actions {
  margin-left: auto;
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Кнопки */
/* Стили для кнопок одинакового размера */
.performance-actions .gradient-btn {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  min-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

/* Специфично для кнопки управления подгруппами */
.subgroup-management-btn {
  padding: 13px 25px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  min-width: 180px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Специфично для кнопки выставить посещаемость */
.set-attendance-btn {
  padding: 13px 25px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  min-width: 180px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.performance-actions .gradient-btn {
  background: #002FA7 !important;
  color: white !important;
  border: none !important;
  border-radius: 13px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.performance-actions .gradient-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;
}

.performance-actions .gradient-btn:active {
  transform: translateY(0) !important;
}

.gradient-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);
}

/* Стили для градиентных кнопок в модальных окнах */
.modal-content .gradient-btn {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;
  border: none !important;
  color: white !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
  white-space: nowrap !important;
  min-width: 180px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
}

.modal-content .gradient-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;
}

.modal-content .gradient-btn:active {
  transform: translateY(0) !important;
}

.modal-content .gradient-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  border-color: #9ca3af !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Специфично для кнопок в модальном окне управления подгруппами */
.tp-subgroup-modal .gradient-btn {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;
  border: none !important;
  color: white !important;
}

.tp-subgroup-modal .gradient-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;
}

/* Кнопка автораспределения */
.auto-distribute-btn {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;
  border: none !important;
  color: white !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
  min-width: 180px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto 20px auto !important;
}

.auto-distribute-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;
}

/* Кнопки в actions модального окна */
.modal-actions .gradient-btn {
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;
  border: none !important;
  color: white !important;
  padding: 10px 20px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
  min-width: 180px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 16px;
}

.modal-actions .gradient-btn:hover:not(:disabled) {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;
}

.modal-actions .gradient-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;
  border-color: #9ca3af !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.clear-distribution-btn {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  margin-left: 10px;
}

.clear-distribution-btn:hover {
  background: linear-gradient(135deg, #ff5252, #e53935);
}

.distribution-info {
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  padding: 10px 15px;
  margin-bottom: 15px;
  border-radius: 4px;
}

.distribution-info p {
  margin: 0;
  color: #495057;
  font-size: 14px;
}

/* Кнопка отмены в модальных окнах */
.modal-actions .cancel-btn {
  padding: 10px 20px !important;
  border: 2px solid #e2e8f0 !important;
  background: white !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  font-weight: 600 !important;
  color: #64748b !important;
  transition: all 0.2s ease !important;
  min-width: 120px !important;
  height: 44px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 16px;
}

.modal-actions .cancel-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-1px) !important;
}

.backs-button {
  background-color: white;
  border: none;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
}

.backs-button:hover {
  background-color: white;
  transform: scale(1.1);  
}

.backs-button img {
  width: 30px;
  height: 30px;
  transition: all 0.2s ease;
}

/* Фильтры */
.performance-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 8px;
  margin-bottom: 20px;
}

.date-range-filter {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-range-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-range-label {
  font-size: 14px;
  font-weight: 400;
  color: #64748b;
  white-space: nowrap;
}

.date-range-input {
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #1e293b;
  background: white;
  cursor: pointer;
  min-width: 80px;
  transition: all 0.2s ease;
  height: 35px;
}

.date-range-input:focus {
  outline: none;
  border-color: #002FA7;
}

/* Стили для кнопки обновления типов занятий */
.refresh-types-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.refresh-types-btn:hover:not(:disabled) {
  border-color: #9ca3af;
  transform: translateY(-0.4px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.refresh-types-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: none;
}

.refresh-types-btn:disabled {
  border-color: #cbd5e1;
  cursor: not-allowed;
  opacity: 0.7;
}

.refresh-types-btn.pc-refreshing {
  border-color: #cbd5e1;
  cursor: not-allowed;
}

/* Иконка обновления */
.filter-select-wrapper .refresh-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}

.filter-select-wrapper .refresh-icon.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .filter-select-wrapper {
    height: 32px;
  }
  
  .filter-select-wrapper .filter-select {
    min-width: 140px;
    font-size: 13px;
  }
  
  .filter-select-wrapper .refresh-types-btn {
    width: 32px;
  }
  
  .filter-select-wrapper .refresh-icon {
    width: 14px;
    height: 14px;
  }
}

.filter-group-with-button {
  display: flex;
  align-items: center;
}

.filter-select-wrapper {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
  height: 35px;
}

.filter-select-wrapper:focus-within {
  border-color: #002FA7;
  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);
}

.filter-select-wrapper .filter-select {
  border: none;
  border-radius: 8px 0 0 8px;
  border-right: 1px solid #e2e8f0;
  min-width: 160px;
  height: 100%;
  margin: 0;
}

.filter-select-wrapper .refresh-types-btn {
  width: 36px;
  height: 100%;
  border: none;
  border-radius: 0 8px 8px 0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0;
}

.filter-select-wrapper .refresh-types-btn:hover:not(:disabled) {
  background: #e2e8f0;
}

.filter-select-wrapper .refresh-types-btn:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.6;
}

.filter-select-wrapper .refresh-types-btn.refreshing {
  background: #e2e8f0;
}


/* Новые стили для заголовков дат */
.date-header-new {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 8px 4px;
}

.date-info-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #002FA7;
  font-size: 16px;
  font-weight: bold;
  transition: all 0.2s ease;
}

.date-info-btn:hover {
  color: #002FA7;
  border-color: #002FA7;
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-title-new {
  font-weight: 600;
  color: #002c9c;
  font-size: 14px;
}

.lesson-type-indicator {
  font-size: 10px;
  color: #666;
  margin-top: 2px;
  font-weight: 500;
}

/* Неактивные отчисленные/переведенные студенты в списке */

.student-inactive {
  background-color: #f8f9fa;
}

.student-inactive .cell-name {
  color: #9ca3af;
}

.inactive-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 10px;
  background-color: #9c9c9c;
  color: white;
  border-radius: 4px;
  text-transform: uppercase;
}

.grade-cell.disabled,
.exam-grade.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Стили для модального окна информации о занятии (успеваемость) */
.lesson-info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.lesson-info-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 95%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.lesson-info-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  border-radius: 12px 12px 0 0;
}

.lesson-info-modal-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 20px;
  font-weight: 600;
}

.lesson-info-modal-close {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 20px;
  cursor: pointer;
  color: #64748b;
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.lesson-info-modal-close:hover {
  background: #e2e8f0;
  color: #374151;
}

.lesson-info-modal-content {
  padding: 0;
  background: white;
}

/* Детальная информация о занятии */
.lesson-details-info {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  overflow: hidden;
}

.info-section-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.info-section-content {
  padding: 20px;
}

/* Сетка 4 колонки для информации о занятии */
.info-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.info-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  text-align: center;
  min-height: 70px;
  justify-content: center;
}

.info-grid-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 1.2;
}

.info-grid-value {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
}

/* Секция управления занятием */
.attendance-stats-section {
  background: white;
  overflow: hidden;
}

.attendance-stats-header {
  background: #f8fafc;
  color: #002FA7;
  margin: 0;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
}

.attendance-stats-content {
  padding: 20px;
}

/* Стили для форм */
.form-group-full-width {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
  box-sizing: border-box;
  cursor: pointer;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-input:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  opacity: 0.7;
}

.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
  box-sizing: border-box;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
  cursor: text;
}

.form-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-textarea:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
  opacity: 0.7;
}

.form-help-text {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}

/* Кнопки действий */
.lesson-info-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .lesson-info-modal {
    width: 95%;
    margin: 20px;
    max-height: 95vh;
  }
  
  .lesson-info-modal-header {
    padding: 20px;
  }
  
  .lesson-info-modal-header h3 {
    font-size: 18px;
  }
  
  .info-section-content,
  .attendance-stats-content {
    padding: 16px;
  }
  
  .info-grid-4 {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
  .info-grid-item {
    padding: 14px 8px;
    min-height: 65px;
  }
  
  .info-grid-value {
    font-size: 13px;
  }
  
  .form-input,
  .form-textarea {
    padding: 10px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .lesson-info-modal-header {
    padding: 16px;
  }
  
  .info-section-content,
  .attendance-stats-content {
    padding: 12px;
  }
  
  .info-grid-4 {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .info-grid-item {
    padding: 12px 8px;
    min-height: 60px;
  }
  
  .info-grid-label {
    font-size: 10px;
  }
  
  .info-grid-value {
    font-size: 12px;
  }
  
  .lesson-info-actions {
    flex-direction: column;
    gap: 12px;
  }
  
  .gradient-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Стили для управления датами */
.date-management-actions {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
}

.add-date-btn {
  padding: 8px 16px;
  font-size: 14px;
}

/* Стили для заголовков дат */
.date-header-new {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-height: 60px;
}

/* Обновленные стили для заголовков дат */
.date-header-new {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 4px;
  min-height: 70px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 8px;
  margin: 2px;
  transition: all 0.3s ease;
  border: 1px solid #f1f5f9;
}

.date-header-new:hover {
  background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);
  border-color: #e0e7ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

/* Контейнер для кнопок */
.date-header-actions {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  opacity: 1;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  padding: 2px;
  backdrop-filter: blur(4px);
  z-index: 10;
}

/* Общие стили для кнопок*/
.date-infos-btn, .date-delete-btn {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  position: relative;
}

/* Кнопка информации*/
.date-infos-btn {
  color: #64748b;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-color: #cad2fe;
}

.date-infos-btn:hover {
  color: #002FA7;
  border-color: #002FA7;
  background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.15);
}

/* Кнопка удаления  */
.date-delete-btn {
  color: #94a3b8;
  background: linear-gradient(135deg, #fef2f2 0%, #ffffff 100%);
  border-color: #fecaca;
}

.date-delete-btn:hover {
  color: #dc2626;
  border-color: #fca5a5;
  background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
  transform: scale(1.1);
  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.15);
}

/* Контент даты  */
.date-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 24px;
  width: 100%;
}

.date-title-new {
  font-weight: 600;
  color: #002c9c;
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
}

.lesson-type-indicator {
  font-size: 10px;
  color: #64748b;
  padding: 2px 6px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Индикатор текущей даты */
.date-header-new.current-date {
  color: #64748b;
  font-weight: 800;
}

.date-header-new.current-date .date-title-new {
  color: #002FA7;
  font-weight: 800;
}

.date-header-new.current-date .lesson-type-indicator {
  background: #002FA7;
  color: white;
}

/* Анимация появления */
@keyframes dateHeaderAppear {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.date-header-new {
  animation: dateHeaderAppear 0.3s ease-out;
}

/* Адаптивность */
@media (max-width: 768px) {
  .date-header-new {
    min-height: 65px;
    padding: 6px 3px;
  }
  
  .date-header-actions {
    opacity: 1;
    background: rgba(255, 255, 255, 0.98);
  }
  
  .date-info-btn, .date-delete-btn {
    width: 20px;
    height: 20px;
    font-size: 11px;
  }
  
  .date-title-new {
    font-size: 12px;
  }
  
  .lesson-type-indicator {
    font-size: 9px;
    padding: 1px 4px;
  }
  
  .date-content {
    margin-top: 20px;
  }
}

/* Стили для пустых дат */
.date-header-new.empty-date {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-color: #e2e8f0;
}

.date-header-new.empty-date .date-title-new {
  color: #94a3b8;
}

/* Эффект при клике */
.date-header-new:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
}

/* Модальные окна для управления датами */
.add-date-modal, .delete-date-modal {
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.available-lessons-list h4 {
  margin-bottom: 15px;
  color: #002FA7;
}

.lessons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 20px;
}

.lesson-item {
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  background: white;
}

.lesson-item:hover {
  border-color: #002FA7;
  background: #f8f9ff;
}

.lesson-item.selected {
  border-color: #002FA7;
  background: #e6f0ff;
}

.lesson-date {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
  color: #002FA7;
}

.lesson-details {
  font-size: 12px;
  color: #666;
}

.lesson-day {
  font-weight: 500;
}

.lesson-type, .lesson-pair {
  margin-top: 2px;
}

.no-lessons-message {
  text-align: center;
  padding: 40px;
  color: #666;
}

.delete-confirmation {
  text-align: center;
  margin-bottom: 20px;
}

.date-to-delete {
  margin: 15px 0;
  padding: 10px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 5px;
  font-size: 16px;
}

.warning-text {
  color: #dc3545;
  font-size: 14px;
  margin-top: 15px;
}

.delete-confirm-btn {
  margin-top: 16px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  height: 42px;
  padding: 10px 28px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.delete-confirm-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #c82333, #bd2130);
}

.delete-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Адаптивность */
@media (max-width: 768px) {
  .lessons-grid {
    grid-template-columns: 1fr;
  }
  
  .date-management-actions {
    flex-direction: column;
  }
  
  .add-date-btn {
    width: 100%;
  }
}

/* Стили для пустого столбца добавления даты */
.column-add-date {
  width: 38px;
  min-width: 38px;
  background-color: transparent;
  border-left: 1px solid #e2e8f0;
  position: relative;
  z-index: 5;
}

.add-date-column {
  height: 30px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  margin: 2px;
  position: relative;
  overflow: hidden;
}

.add-date-column:hover {
  background: white;
  border-color: #002FA7;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.15);
}

.add-date-column::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 47, 167, 0.05), transparent);
  transition: left 0.3s;
}

.add-date-column:hover::before {
  left: 100%;
}

.add-date-plus {
  font-size: 20px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
}

.add-date-column:hover .add-date-plus {
  color: #002FA7;
  transform: scale(1.05);
}

.add-date-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 40px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  margin: 1px;
  position: relative;
  overflow: hidden;
}

.add-date-cell:hover {
  background: white;
  border-color: #002FA7;
  box-shadow: 0 1px 4px rgba(0, 47, 167, 0.1);
}

.add-date-cell::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 47, 167, 0.03), transparent);
  transition: left 0.3s;
}

.add-date-cell:hover::before {
  left: 100%;
}

.add-date-cell-plus {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
}

.add-date-cell:hover .add-date-cell-plus {
  color: #002FA7;
}

/* Анимация при клике */
.add-date-column:active,
.add-date-cell:active {
  transform: translateY(0);
  transition: transform 0.1s ease;
  background: #f8fafc;
}

/* Состояние disabled */
.add-date-column:disabled,
.add-date-cell:disabled {
  background: #f8fafc;
  border-color: #e2e8f0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.add-date-column:disabled .add-date-plus,
.add-date-cell:disabled .add-date-cell-plus {
  color: #94a3b8;
}

.add-date-column:disabled:hover::before,
.add-date-cell:disabled:hover::before {
  left: -100%;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .column-add-date {
    width: 45px;
    min-width: 45px;
  }
  
  .add-date-column {
    min-height: 45px;
    margin: 1px;
  }
  
  .add-date-plus {
    font-size: 18px;
  }
  
  .add-date-cell {
    min-height: 35px;
  }
  
  .add-date-cell-plus {
    font-size: 14px;
  }
}

/* Стили для расширенного режима */
.teacher-performance-section.expanded .column-add-date,
body.menu-collapsed .column-add-date {
  width: 42px;
  min-width: 42px;
}

.teacher-performance-section.expanded .add-date-column,
body.menu-collapsed .add-date-column {
  height: 38px;
  min-height: 38px;
}

.teacher-performance-section.expanded .add-date-cell,
body.menu-collapsed .add-date-cell {
  min-height: 38px;
}

/* Интеграция с sticky колонками */
.sticky-col-right {
  position: sticky;
  right: 0;
  z-index: 10;
}

/* Убедитесь, что столбец добавления даты всегда виден при скролле */
.performance-table-wrapper {
  position: relative;
}

.column-add-date {
  position: relative;
  z-index: 5;
}

/* Состояние загрузки */
.add-date-column.loading,
.add-date-cell.loading {
  pointer-events: none;
  opacity: 0.7;
}

.add-date-column.loading .add-date-plus,
.add-date-cell.loading .add-date-cell-plus {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Фокус состояния для доступности */
.add-date-column:focus-visible,
.add-date-cell:focus-visible {
  outline: 2px solid #002FA7;
  outline-offset: 1px;
  border-color: #002FA7;
}

/* Улучшенная интеграция с таблицей */
.performance-table th.column-add-date {
  background: white;
  border-bottom: 1px solid #e2e8f0;
}

.performance-table td.column-add-date {
  background: white;
  border-bottom: 1px solid #f1f5f9;
}

/* Подсветка при наведении на строку */
.performance-table tbody tr:hover td.column-add-date {
  background: #f8fafc;
}

/* Расширенное модальное окно информации о занятии */
.pc-modal.expanded {
  max-width: 600px !important;
  width: 95% !important;
}

/* Выравнивание ширины селектора типа занятия с полем темы */
.pc-form-grid .pc-form-group.editable-field {
  grid-column: 1 / -1;
}

.pc-form-grid .pc-form-group.editable-field select.pc-input {
  width: 100%;
}

/* Убедимся, что все поля имеют одинаковую ширину */
.pc-form-grid .pc-form-group .pc-input {
  width: 100%;
  box-sizing: border-box;
}

/* Специфично для селектора типа занятия */
.pc-form-group.editable-field select.pc-input {
  width: 100% !important;
  min-width: auto !important;
}

/* Адаптивность для расширенного модального окна */
@media (max-width: 768px) {
  .pc-modal.expanded {
    width: 98% !important;
    margin: 10px;
  }
}

.pc-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.pc-input::placeholder {
  color: #9ca3af;
}

/* Стили для select и textarea внутри .pc-input */
.pc-input select,
.pc-input textarea {
  border: none;
  outline: none;
  width: 100%;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
}

.pc-input textarea {
  resize: vertical;
  min-height: 80px;
  line-height: 1.5;
}

.pc-modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #f3f4f6;
}

.pc-confirm-btn {
  padding: 12px 32px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.pc-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.pc-confirm-btn:active:not(:disabled) {
  transform: translateY(0);
}

.pc-confirm-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .pc-modal {
    width: 98%;
    margin: 20px;
  }
  
  .pc-form-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .pc-modal-content {
    padding: 20px;
  }
}

.type-filters {
  display: flex;
  align-items: center;
  text-align: center;
  gap: 12px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-select {
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  text-align: left;
  color: #1e293b;
  background: white;
  cursor: pointer;
  width: 174px;
  transition: all 0.2s ease;
  height: 35px;
}

.filter-select:focus {
  outline: none;
  border-color: #002FA7;
}

/* Контейнер таблицы */
.performance-table-container {
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.performance-table-wrapper {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.performance-table {
  min-width: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

/* При расширенном режиме увеличиваем ширину таблицы */
.teacher-performance-section.expanded .performance-table,
body.menu-collapsed .performance-table {
  min-width: 1200px;
}

.performance-table th {
  background: white;
  color: #002c9c;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 8px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 30;
}

/* Выделенные колонки */
.highlight-col {
  background: #f0f4ff !important;
}

/* Стили для скрытия столбца подгрупп когда один преподаватель */
.teacher-performance-section.no-subgroups .column-subgroup {
  display: none;
}

.teacher-performance-section.no-subgroups .column-name {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}

/* Для мобильных устройств */
@media (max-width: 768px) {
  .teacher-performance-section.no-subgroups .column-name {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
  }
}

/* Фиксированные заголовки */
.performance-table th.column-number,
.performance-table th.column-name,
.performance-table th.column-subgroup,
.performance-table th.column-average,
.performance-table th.column-exam {
  position: sticky;
  z-index: 50;
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.performance-table th.column-number {
  left: 0;
  border-right: 2px solid #e2e8f0;
}

.performance-table th.column-name {
  left: 60px;
  border-right: 2px solid #e2e8f0;
}

.performance-table th.column-subgroup {
  left: 310px;
  border-right: 2px solid #e2e8f0;
}

.performance-table th.column-average {
  right: 120px;
  border-left: 2px solid #e2e8f0;
}

.performance-table th.column-exam {
  right: 0;
  border-left: 2px solid #e2e8f0;
}

.performance-table td {
  padding: 8px 4px;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  height: 70px;
  position: relative;
  z-index: 1;
}

/* Фиксированные ячейки */
.performance-table td.column-number,
.performance-table td.column-name,
.performance-table td.column-subgroup,
.performance-table td.column-average,
.performance-table td.column-exam {
  position: sticky;
  z-index: 40;
  background: white;
}

.performance-table td.column-number {
  left: 0;
  border-right: 2px solid #e2e8f0;
}

.performance-table td.column-name {
  left: 60px;
  border-right: 2px solid #e2e8f0;
  text-align: left !important;
}

.performance-table td.column-subgroup {
  left: 310px;
  border-right: 2px solid #e2e8f0;
}

.performance-table td.column-average {
  right: 120px;
  border-left: 2px solid #e2e8f0;
}

.performance-table td.column-exam {
  right: 0;
  border-left: 2px solid #e2e8f0;
}

/* Подсветка при наведении на строку */
.performance-table tbody tr:hover td.column-number,
.performance-table tbody tr:hover td.column-name,
.performance-table tbody tr:hover td.column-subgroup,
.performance-table tbody tr:hover td.column-average,
.performance-table tbody tr:hover td.column-exam {
  background: #f0f4ff;
}

/* Конкретные размеры и позиции колонок */
.column-number {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.column-name {
  width: 250px;
  min-width: 250px;
  max-width: 250px;
  text-align: left;
}

.column-subgroup {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.column-date {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.column-average {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.column-exam {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

/* При расширенном режиме увеличиваем ширину некоторых колонок */
.teacher-performance-section.expanded .column-name,
body.menu-collapsed .column-name {
  width: 300px;
  min-width: 300px;
  max-width: 300px;
}

.teacher-performance-section.expanded .column-date,
body.menu-collapsed .column-date {
  width: 90px;
  min-width: 90px;
  max-width: 90px;
}

/* Стили для ячеек */
.cell-number {
  font-weight: 600;
  color: #002FA7;
  font-size: 14px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.cell-name {
  text-align: left !important;
  padding: 12px 16px !important;
  font-weight: 500;
  color: #1e293b;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-subgroup {
  font-weight: 500;
  color: #64748b;
  font-size: 13px;
  text-align: center;
}

.subgroup-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.subgroup-select:focus {
  outline: none;
  border-color: #002FA7;
}

/* Контейнер ячейки с оценкой */
.grade-cell-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  height: 100%;
  justify-content: center;
  padding: 4px 0;
}

/* Оценка */
.grade-cell {
  height: 36px;
  width: 36px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: white !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

/* Стили для текста оценок */
.grade-value, .exam-grade-value, .average-grade {
  color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Размеры для разных оценок */

.grade-cell.large {
  width: 45px;
  height: 45px;
  font-size: 10px;
  min-width: 45px;
  min-height: 45px;
}

.grade-cell:hover {
  transform: scale(1.15);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

/* Цвета для оценок */
.grade-excellent {
  background: #2cbb00;
}

.grade-good {
  background: #a5db28;
}

.grade-satisfactory {
  background: #f59e0b;
}

.grade-unsatisfactory {
  background: #ef4444;
}

.grade-empty {
  background: transparent;
  border: 1px solid #cbd5e1;
  color: #94a3b8 !important;
  text-shadow: none;
  font-weight: 600;
  transition: all 0.2s ease;
}

.grade-empty:hover {
  border-color: #002FA7;
  color: #002FA7 !important;
  background: #f0f4ff;
}

/* Стили для input при редактировании */
.grade-input {
  width: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
  color: #1e293b !important;
  outline: none;
}

.grade-input::placeholder {
  color: rgba(156, 156, 156, 0.7);
  font-weight: 400;
}

/* Средний балл */
.average-grade {
  font-weight: 700;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 8px;
  display: inline-block;
  min-width: 60px;
  text-align: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border: 2px solid transparent;
}

/* Экзамен */
.exam-cell-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.exam-grade {
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  border: 2px solid transparent;
  min-width: 40px;
  min-height: 30px;
}

.exam-grade:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

/* Цвета для экзаменационных оценок */
.exam-grade-excellent {
  background: #2cbb00;
}

.exam-grade-good {
  background: #a5db28;
}

.exam-grade-satisfactory {
  background: #f59e0b;
}

.exam-grade-unsatisfactory {
  background: #ef4444;
}

.exam-grade-pass {
  background: #2cbb00;
}

.exam-grade-fail {
  background: #ef4444;
}

.exam-grade-empty {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  color: #94a3b8 !important;
  text-shadow: none;
  font-weight: 600;
}

.exam-grade-empty:hover {
  border-color: #002FA7;
  color: #002FA7 !important;
  background: #f0f4ff;
}

.exam-grade-select {
  width: 100%;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 700;
  font-size: 13px;
  color: #1e293b !important;
  outline: none;
  cursor: pointer;
}

.exam-grade-value {
  padding: 2px 4px;
}

/* Модальные окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  min-width: 500px;
  max-width: 600px;
}

.modal-content h3 {
  margin: 0 0 16px 0;
  color: #002FA7;
  font-size: 18px;
}

.modal-content textarea {
  width: 100%;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  margin-bottom: 16px;
}

.modal-content textarea:focus {
  outline: none;
  border-color: #002FA7;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.cancel-btn {
  padding: 8px 16px;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  border-color: #64748b;
  background: #f8fafc;
}

/* Стили для скроллбара */
.performance-table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.performance-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.performance-table-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.performance-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Стили для отображения типа аттестации в заголовке */
.global-exam-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  padding: 8px 4px;
}

.global-exam-header .exam-type-code {
  font-size: 16px;
  font-weight: 700;
  color: #002FA7;
}

.global-exam-header .exam-type-label {
  font-size: 11px;
  color: #64748b;
}

/* Когда аттестация не назначена */
.column-exam.no-certification {
  opacity: 0.5;
  pointer-events: none;
}

.column-exam.no-certification .global-exam-header {
  color: #94a3b8;
}

/* Индикатор сохранения экзамена */
.exam-saving-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px;
}

.exam-saving-spinner span {
  font-size: 11px;
  font-weight: 500;
  color: white;
}

.loading-spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: exam-spin 0.8s linear infinite;
}

@keyframes exam-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Контейнер ячейки экзамена */
.exam-cell-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-height: 90px;
}

.exam-grade {
  cursor: pointer;
  padding: 10px 12px;
  border-radius: 8px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  border: 2px solid transparent;
  min-width: 90px;
  width: 100%;
}

.exam-grade-value {
  font-size: 16px;
  font-weight: 700;
}

.retake-checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 11px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.retake-checkbox-label:hover {
  background: white;
}

.retake-checkbox {
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin: 0;
}

.retake-label {
  color: #1e293b;
  font-weight: 500;
  font-size: 11px;
}

.certification-none {
  padding: 6px 10px;
  background: #f1f5f9;
  border-radius: 8px;
  color: #64748b;
  font-size: 12px;
  margin-top: 8px;
}

.certification-error {
  padding: 6px 10px;
  background: #fef2f2;
  border-radius: 8px;
  color: #dc2626;
  font-size: 12px;
  margin-top: 8px;
}

/* Кнопка комментария */
.comment-btn {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  padding: 4px;
  color: #64748b;
  transition: all 0.3s ease;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  position: relative;
}

/* Обновленные стили для комментариев */
.comment-history-item {
  padding: 16px;
  background: white;
  border-bottom: 1px solid #f1f5f9;
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.comment-history-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
}

.comment-date {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.comment-author-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.teacher-badge {
  background: #dbeafe;
  color: #1e40af;
}

.student-badge {
  background: #dbeafe;
  color: #1e40af;
}

.comment-text {
  font-size: 14px;
  color: #1e293b;
  line-height: 1.5;
  margin-bottom: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid #002FA7;
}

.comment-files {
  margin-top: 12px;
}

.files-header {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.files-grid-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 8px;
}

.file-item-preview-compact {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
  background: white;
  transition: all 0.2s ease;
}

.file-item-preview-compact:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.explorer-upload-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #002FA7 0%, #0f53ff 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.explorer-upload-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);
  transform: translateY(-1px);
}

.explorer-upload-btn:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

/* Стили для информации о форматах */
.file-formats-info {
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
}

/* Компактные стили для файлов */
.file-preview {
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 8px;
}

.file-info-compact {
  flex: 1 1;
  min-width: 0;
}

.file-name-compact {
  font-size: 12px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin-bottom: 4px;
}

.file-actions {
  display: flex;
  gap: 8px;
}

.file-link, .download-link {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.file-link {
  background: #f3f4f6;
  color: #374151;
}

.file-link:hover {
  background: #e5e7eb;
}

.download-link {
  background: #dbeafe;
  color: #1e40af;
}

.download-link:hover {
  background: #c7d2fe;
}

/* Индикатор файлов в кнопке комментария */
.file-indicator {
  font-size: 10px;
  margin-left: 2px;
}

/* Адаптивность */
@media (max-width: 768px) {
  .file-preview-modal {
    max-width: 95vw;
    max-height: 95vh;
    margin: 10px;
  }
  
  .file-preview-actions {
    flex-direction: column;
    gap: 12px;
  }
  
  .files-grid-compact {
    grid-template-columns: 1fr;
  }
}

.download-btn-simple:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  position: relative;
}

.download-btn-simple:disabled::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  border: 2px solid transparent;
  border-top: 2px solid #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.file-item-simple {
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #f8f9fa;
}

.file-icon {
  margin-right: 12px;
  font-size: 18px;
}

.file-info-simple {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

.file-name-simple {
  font-size: 14px;
  color: #333;
  flex-grow: 1;
  margin-right: 12px;
}

.download-btn-simple {
  background: #002FA7;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.2s;
}

.download-btn-simple:hover:not(:disabled) {
  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);
  transform: translateY(-1px);
}

/* Стили для вкладок комментариев */

/* Новые стили для вкладок на весь экран */
.comment-tabs-fullwidth {
  display: flex;
  width: 100%;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 20px;
  background: #f8fafc;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.comment-tab-fullwidth {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.3s ease;
  position: relative;
}

.comment-tab-fullwidth:hover {
  background: #f1f5f9;
  color: #002FA7;
}

.comment-tab-fullwidth.active {
  background: white;
  color: #002FA7;
  border-bottom-color: #002FA7;
  box-shadow: 0 -2px 8px rgba(0, 47, 167, 0.1);
}

.tab-title {
  white-space: nowrap;
}

.tab-badge-fullwidth {
  background: #002FA7;
  color: white;
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}

.comment-tab-fullwidth.active .tab-badge-fullwidth {
  background: white;
  color: #002FA7;
  border: 1px solid #002FA7;
}

.tab-content-fullwidth {
  animation: fadeIn 0.3s ease;
  min-height: 400px;
  max-height: 60vh;
  overflow-y: auto;
}

/* Простые стили для файлов */
.file-item-simple {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 8px;
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.file-item-simple:hover {
  border-color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.15);
  transform: translateY(-1px);
}

.file-info-simple {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1;
  margin-left: 8px;
}

.file-name-simple {
  font-size: 14px;
  color: #374151;
  flex: 1 1;
}

.download-btn-simple {
  padding: 8px 16px;
  background: linear-gradient(135deg, #002FA7 0%, #0f53ff 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 12px;
  transition: all 0.2s ease;
  font-weight: 600;
}

.download-btn-simple:hover {
  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);
}

.file-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.comment-files-simple {
  margin-top: 12px;
}

.files-header-simple {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.files-list-simple {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Стили для существующих файлов */
.existing-files-section {
  margin-top: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  background: #f8fafc;
}

.view-file-btn {
  padding: 4px 8px;
  background: #002FA7;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  transition: all 0.2s ease;
}

.view-file-btn:hover {
  background: #001f7a;
  transform: translateY(-1px);
}

/* Расширенное модальное окно комментариев */
.comment-modal.expanded {
  max-width: 900px !important;
  max-height: 95vh !important;
  width: 95vw !important;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

/* Увеличенные области контента */
.comment-modal.expanded .comment-input-section {
  flex-shrink: 0;
  margin-bottom: 0;
}

.comment-modal.expanded .comment-textarea {
  min-height: 100px;
  font-size: 14px;
}

.comment-modal.expanded .comment-history-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.comment-modal.expanded .comment-history-list {
  flex: 1 1;
  max-height: none !important;
  min-height: 160px;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .comment-tabs {
    flex-direction: column;
  }
  
  .comment-tab {
    text-align: center;
    border-bottom: 1px solid #e2e8f0;
    border-left: 2px solid transparent;
  }
  
  .comment-tab.active {
    border-bottom-color: #e2e8f0;
    border-left-color: #002FA7;
  }
}

/* Стили для вкладок комментариев */
.comment-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 16px;
  position: relative;
}

.comment-tab {
  position: relative;
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.comment-tab:hover {
  color: #002FA7;
  background: #f8fafc;
}

.comment-tab.active {
  color: #002FA7;
  border-bottom-color: #002FA7;
  background: #f0f4ff;
}

.tab-badge {
  background: #002FA7;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
}

/* Стили для истории комментариев */
.comment-history-section {
  margin-top: 16px;
}

.comment-history-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.comment-history-item {
  padding: 16px;
  background: white;
  border-bottom: 1px solid #f1f5f9;
}

.comment-history-item:last-child {
  border-bottom: none;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
}

.comment-date {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
}

.comment-action {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  flex: 1 1;
  text-align: right;
}

.comment-text {
  font-size: 14px;
  color: #1e293b;
  line-height: 1.4;
  margin-bottom: 12px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid #002FA7;
}

.comment-files {
  margin-top: 12px;
}

.comment-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 8px 0;
}

/* Стили для состояний загрузки и пустых состояний */
.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  color: #64748b;
  gap: 12px;
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-comments-section {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 8px;
  border: 2px dashed #e2e8f0;
}

/* Стили для секции ввода комментария преподавателя */
.comment-input-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

/* Расширенное модальное окно комментариев */
.comment-modal.expanded {
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .comment-tabs {
    flex-direction: column;
  }
  
  .comment-tab {
    text-align: center;
    border-bottom: 1px solid #e2e8f0;
    border-left: 2px solid transparent;
    justify-content: center;
  }
  
  .comment-tab.active {
    border-bottom-color: #e2e8f0;
    border-left-color: #002FA7;
  }
  
  .comment-header {
    flex-direction: column;
    gap: 4px;
  }
  
  .comment-action {
    text-align: left;
  }
}

.comment-btn.has-teacher-comment {
  border-color: rgb(169, 171, 173);
  color: #a7aab4;
  box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);
}

.comment-btn.has-teacher-comment:hover {
  background: #e1e2e6;
  border-color: #a7aab4;
  transform: scale(1.1);
}

.comment-btn.has-student-comment:hover {
  background: #e0e6fe;
  border-color: #1d4ed8;
  transform: scale(1.1);
}

.comment-btn.has-student-comment {
  border-color: #6088c9;
  color: #1d4ed8;
  box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);
}

.comment-btn.has-both-comments {
  border-color: #f59e0b;
  color: #d97706;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
}

/* Для комментария к оценке */
.comment-modal {
  max-width: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  padding: 24px;
}

.comment-textarea-container {
  position: relative;
}

.comment-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.2s;
  min-height: 100px;
}

.comment-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.attached-files-section {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  background: #f8fafc;
  margin-top: 8px;
}

.files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.files-header span {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.files-instruction {
  font-size: 12px;
  color: #64748b;
  background: #f1f5f9;
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  border-left: 3px solid #3b82f6;
}

.files-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: white;
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
  position: relative;
}

.file-item:hover {
  background: #f8fafc;
}

.file-item:last-child {
  border-bottom: none;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}

.file-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  color: #64748b;
  flex-shrink: 0;
  font-size: 16px;
}

.file-name {
  font-size: 13px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  font-size: 12px;
  color: #64748b;
  margin-left: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

.file-preview {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 12px;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.remove-file-btn {
  background: transparent;
  color: #64748b;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-left: 8px;
}

.remove-file-btn:hover {
  background: #ef4444;
  color: white;
  border-color: #ef4444;
  transform: scale(1.05);
}

/* Стили для скроллбара */
.files-list::-webkit-scrollbar {
  width: 6px;
}

.files-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.files-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.files-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Состояние когда файлов нет */
.no-files-placeholder {
  text-align: center;
  padding: 30px 20px;
  color: #64748b;
  font-size: 13px;
  background: white;
  border-radius: 6px;
  border: 2px dashed #e2e8f0;
  background: #fafafa;
}

.file-type-badge {
  background: #f1f5f9;
  color: #475569;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  margin-left: 8px;
  font-weight: 500;
}

/* Превью изображений */
.image-preview-container {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}

/* Стили для состояния ошибки */
.error-state {
  text-align: center;
  padding: 60px 40px;
  color: #ef4444;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin: 20px 0;
}

.error-message {
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.5;
  color: #1e293b;
}

.error-message strong {
  color: #ef4444;
  font-weight: 600;
}

/* Стили для кнопки "Повторить попытку" */
.retry-button {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  border: 2px solid rgba(239, 68, 68, 0.3);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
}

.retry-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.3);
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
}

.retry-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);
}

.retry-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}

/* Анимация для кнопки при наведении */
.retry-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.retry-button:hover::before {
  left: 100%;
}

/* Иконка обновления */
.retry-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}

.retry-button:hover .retry-icon {
  transform: rotate(180deg);
}

/* Стили для иконки ошибки */
.error-icon {
  font-size: 48px;
  margin-bottom: 16px;
  color: #ef4444;
  opacity: 0.8;
}

/* Блок среднего балла группы */
.group-average-footer {
  padding: 16px 14px;
  background: transparent;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.group-average-percentage {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: white;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.average-circle {
  width: 62px;
  height: 62px;  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: conic-gradient(
    var(--average-color, #ffffff) 0% var(--average, 0%),
    #f1f5f9 var(--average, 0%) 100%
  );
}

.average-circle::before {
  content: '';
  position: absolute;
  width: 52px;
  height: 52px;
  background: white;
  border-radius: 50%;
  align-items: center;
}

.average-value {
  font-size: 15px; 
  font-weight: 800;
  z-index: 1;
  color: var(--average-color, #ffffff);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.average-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  padding-right: 5px;
}

/* Стили для заголовка таблицы с rowspan */
.table-header-rowspan {
  vertical-align: middle;
  text-align: center;
}

/* Стили для отображения преподавателя в фильтрах */

.teacher-value-readonly {
  font-size: 14px;
  color: #002FA7;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

/* Модальное окно подгрупп с th- префиксом */
.th-subgroup-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(50, 64, 124, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.th-subgroup-modal {
  background: white;
  border-radius: 12px;
  padding: 0;
  width: 95%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  animation: th-modal-appear 0.2s ease-out;
}

@keyframes th-modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.th-subgroup-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border-radius: 12px 12px 0 0;
  color: white;
}

.th-subgroup-modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: white;
}

.th-subgroup-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  padding: 4px 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.th-subgroup-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.th-subgroup-modal-content {
  padding: 24px;
}

.th-subgroup-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-bottom: 24px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.th-subgroup-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 120px;
}

.th-stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #002FA7;
}

.th-stat-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
  text-align: center;
}

.th-auto-distribute-section {
  margin-bottom: 24px;
  text-align: center;
}

.th-auto-distribute-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 180px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.th-auto-distribute-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.th-auto-distribute-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.th-students-section {
  margin-bottom: 24px;
}

.th-students-section h4 {
  margin: 0 0 12px 0;
  color: #002FA7;
  font-size: 16px;
  font-weight: 600;
}

.th-students-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.th-student-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: white;
  transition: all 0.2s ease;
}

.th-student-item:hover {
  border-color: #002FA7;
  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.1);
}

.th-student-name {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
}

.th-subgroup-select {
  width: 140px;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.th-subgroup-select:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);
}

.th-subgroup-select:disabled {
  background: #f1f5f9;
  cursor: not-allowed;
  opacity: 0.7;
}

.th-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.th-cancel-btn {
  padding: 10px 20px;
  border: 2px solid #e2e8f0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s ease;
  min-width: 120px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.th-cancel-btn:hover:not(:disabled) {
  border-color: #64748b;
  background: #f8fafc;
  transform: translateY(-1px);
}

.th-cancel-btn:disabled {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #9ca3af;
  cursor: not-allowed;
  transform: none;
}

.th-save-btn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 180px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.th-save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);
}

.th-save-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.th-save-btn.th-loading {
  position: relative;
  color: transparent;
  pointer-events: none;
}

.th-save-btn.th-loading::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -10px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: th-button-spin 0.8s linear infinite;
}

@keyframes th-button-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .th-subgroup-modal {
    width: 98%;
    max-height: 95vh;
  }
  
  .th-subgroup-stats {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }
  
  .th-subgroup-stat {
    flex-direction: row;
    justify-content: space-between;
    min-width: auto;
  }
  
  .th-auto-distribute-btn {
    width: 100%;
  }
  
  .th-student-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .th-subgroup-select {
    width: 100%;
  }
  
  .th-modal-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .th-cancel-btn,
  .th-save-btn {
    width: 100%;
  }
}

/* Стили для заголовка с кнопками информации и обновления */
.performance-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
}

.header-left-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Стили для кнопок в заголовке */
.header-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.header-btn:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.header-btn:active {
  transform: translateY(0);
}

/* Стили для сетки оценок */
.grades-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.grades-row {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.grade-demo {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  font-weight: 700;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

/* Цвета для оценок */
.grade-excellent {
  background: #2cbb00;
}

.grade-good {
  background: #a5db28;
}

.grade-satisfactory {
  background: #f59e0b;
}

.grade-unsatisfactory {
  background: #ef4444;
}

.grades-note {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: #64748b;
}

.grades-note code {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  color: #002FA7;
  font-weight: 600;
  border: 1px solid #e2e8f0;
}

@media (max-width: 480px) {
  .info-tooltip {
    width: 95vw;
    padding: 12px;
    left: 0;
    transform: translateY(8px);
    margin-left: 0;
  }
  
  .info-tooltip::before {
    left: 20px;
  }
  
  .info-tooltip-content {
    font-size: 13px;
  }
}

@keyframes pc-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Стили для кнопки обновления */
.pc-refresh-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pc-refresh-btn.pc-refreshing {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
}

.pc-refresh-icon {
  width: 18px;
  height: 18px;
  transition: all 0.3s ease;
  filter: brightness(0.8);
}

.pc-refresh-spin {
  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  filter: brightness(1);
}

@keyframes pc-spin {
  0% { 
    transform: rotate(0deg);
    filter: brightness(0.8);
  }
  50% {
    filter: brightness(1.2);
  }
  100% { 
    transform: rotate(360deg);
    filter: brightness(0.8);
  }
}

/* Эффект пульсации для кнопки во время обновления */
.pc-refresh-btn.pc-refreshing::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .performance-cabinet-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .header-btn {
    justify-content: center;
    width: 100%;
  }
  
  .info-tooltip {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    min-width: 280px;
    max-width: 90vw;
  }
  
  .info-icon-btn:hover .info-tooltip {
    opacity: 0;
    visibility: hidden;
  }
  
  .info-icon-btn:focus .info-tooltip,
  .info-icon-btn:active .info-tooltip {
    opacity: 1;
    visibility: visible;
  }
}

@media (max-width: 480px) {
  .header-btn {
    padding: 8px 12px;
    font-size: 13px;
  }
  
  .info-tooltip-content {
    padding: 12px;
    font-size: 12px;
  }
}

/* Адаптивность */
@media (max-width: 768px) {
  .subgroup-stats {
    flex-direction: column;
    gap: 10px;
  }
  
  .student-subgroup-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .subgroup-select-modal {
    width: 100%;
  }
}

/* Адаптивность */
@media (max-width: 768px) {
  .teacher-performance-section {
    width: 100%;
    min-width: 100%;
    padding: 12px;
  }
  
  .teacher-performance-section.expanded,
  body.menu-collapsed .teacher-performance-section {
    width: 100% !important;
  }
  
  .performance-filters {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .performance-title-container {
    flex-direction: column;
    gap: 16px;
  }
  
  .performance-actions {
    justify-content: space-between;
    width: 100%;
  }
  
  .modal-content {
    min-width: 90vw;
    margin: 20px;
  }
  
  .column-name {
    width: 200px;
    min-width: 200px;
  }
  
  .column-number {
    width: 50px;
    min-width: 50px;
  }
  
  .column-subgroup {
    width: 80px;
    min-width: 80px;
  }
  
  .grade-cell {
    min-width: 35px;
    min-height: 25px;
    font-size: 12px;
  }

  .error-state {
    padding: 40px 20px;
    margin: 16px 0;
  }
  
  .error-message {
    font-size: 14px;
    margin-bottom: 20px;
  }
  
  .retry-button {
    padding: 10px 20px;
    font-size: 13px;
    min-width: 140px;
  }

  /* Принудительное исправление курсоров */
.pc-modal .pc-input {
  cursor: pointer !important;
}

.pc-modal .pc-input:read-only {
  cursor: not-allowed !important;
}

.pc-modal .pc-input[readonly] {
  cursor: not-allowed !important;
}

.pc-modal textarea.pc-input {
  cursor: text !important;
}

}`, "",{"version":3,"sources":["webpack://./src/th-components/TeacherPerformanceSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,4DAA4D;EAC5D,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,WAAW;AACX,yCAAyC;AACzC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,mDAAmD;AACnD;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,6BAA6B;AAC7B;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,qCAAqC;AACrC;EACE,wEAAwE;EACxE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA;EACE,wEAAwE;EACxE,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,0DAA0D;;AAE1D;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,qCAAqC;EACvC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oFAAoF;EACpF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;;EAEE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,QAAQ;EACR,WAAW;AACb;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;;EAEE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;;EAEE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;;;;;EAKE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;;;;;EAKE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;;;;;EAKE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,mCAAmC;;AAEnC,0CAA0C;AAC1C;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,6DAA6D;EAC7D,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mDAAmD;;AAEnD;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qFAAqF;EACrF,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,OAAO;IACP,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,wCAAwC;AAC1C;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA","sourcesContent":[".teacher-performance-section {\n  width: 1000px;\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  padding: 0;\n  margin-bottom: 0;\n  position: relative;\n  transition: width 0.3s ease;\n}\n\n/* Стили для расширенного режима */\n.teacher-performance-section.expanded {\n  width: 1200px !important;\n}\n\n/* Стили когда меню свернуто */\nbody.menu-collapsed .teacher-performance-section {\n  width: 1200px !important;\n}\n\n/* Заголовок */\n.performance-header {\n  margin-bottom: 24px;\n  padding: 0 8px;\n  width: 100%;\n}\n\n.performance-title-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.performance-title {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n.group-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0;\n}\n\n.subject-full-title {\n  font-size: 16px;\n  color: #64748b;\n  font-weight: 400;\n  line-height: 1.4;\n  text-align: left;\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 600px;\n}\n\n.performance-actions {\n  margin-left: auto;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Кнопки */\n/* Стили для кнопок одинакового размера */\n.performance-actions .gradient-btn {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  min-width: 180px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n/* Специфично для кнопки управления подгруппами */\n.subgroup-management-btn {\n  padding: 13px 25px !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  min-width: 180px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Специфично для кнопки выставить посещаемость */\n.set-attendance-btn {\n  padding: 13px 25px !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  min-width: 180px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.performance-actions .gradient-btn {\n  background: #002FA7 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 13px !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.performance-actions .gradient-btn:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;\n}\n\n.performance-actions .gradient-btn:active {\n  transform: translateY(0) !important;\n}\n\n.gradient-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);\n}\n\n/* Стили для градиентных кнопок в модальных окнах */\n.modal-content .gradient-btn {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;\n  border: none !important;\n  color: white !important;\n  padding: 10px 20px !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  transition: all 0.2s ease !important;\n  white-space: nowrap !important;\n  min-width: 180px !important;\n  height: 44px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  text-decoration: none !important;\n}\n\n.modal-content .gradient-btn:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;\n}\n\n.modal-content .gradient-btn:active {\n  transform: translateY(0) !important;\n}\n\n.modal-content .gradient-btn:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;\n  border-color: #9ca3af !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Специфично для кнопок в модальном окне управления подгруппами */\n.tp-subgroup-modal .gradient-btn {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;\n  border: none !important;\n  color: white !important;\n}\n\n.tp-subgroup-modal .gradient-btn:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;\n}\n\n/* Кнопка автораспределения */\n.auto-distribute-btn {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;\n  border: none !important;\n  color: white !important;\n  padding: 10px 20px !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  transition: all 0.2s ease !important;\n  min-width: 180px !important;\n  height: 44px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin: 0 auto 20px auto !important;\n}\n\n.auto-distribute-btn:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;\n}\n\n/* Кнопки в actions модального окна */\n.modal-actions .gradient-btn {\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%) !important;\n  border: none !important;\n  color: white !important;\n  padding: 10px 20px !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  transition: all 0.2s ease !important;\n  min-width: 180px !important;\n  height: 44px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin-top: 16px;\n}\n\n.modal-actions .gradient-btn:hover:not(:disabled) {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3) !important;\n}\n\n.modal-actions .gradient-btn:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%) !important;\n  border-color: #9ca3af !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.clear-distribution-btn {\n  background: linear-gradient(135deg, #ff6b6b, #ee5a52);\n  margin-left: 10px;\n}\n\n.clear-distribution-btn:hover {\n  background: linear-gradient(135deg, #ff5252, #e53935);\n}\n\n.distribution-info {\n  background-color: #f8f9fa;\n  border-left: 4px solid #007bff;\n  padding: 10px 15px;\n  margin-bottom: 15px;\n  border-radius: 4px;\n}\n\n.distribution-info p {\n  margin: 0;\n  color: #495057;\n  font-size: 14px;\n}\n\n/* Кнопка отмены в модальных окнах */\n.modal-actions .cancel-btn {\n  padding: 10px 20px !important;\n  border: 2px solid #e2e8f0 !important;\n  background: white !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  font-weight: 600 !important;\n  color: #64748b !important;\n  transition: all 0.2s ease !important;\n  min-width: 120px !important;\n  height: 44px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin-top: 16px;\n}\n\n.modal-actions .cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.3) !important;\n  transform: translateY(-1px) !important;\n}\n\n.backs-button {\n  background-color: white;\n  border: none;\n  padding: 0;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n}\n\n.backs-button:hover {\n  background-color: white;\n  transform: scale(1.1);  \n}\n\n.backs-button img {\n  width: 30px;\n  height: 30px;\n  transition: all 0.2s ease;\n}\n\n/* Фильтры */\n.performance-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 8px;\n  margin-bottom: 20px;\n}\n\n.date-range-filter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.date-range-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.date-range-label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.date-range-input {\n  padding: 8px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  min-width: 80px;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.date-range-input:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Стили для кнопки обновления типов занятий */\n.refresh-types-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.refresh-types-btn:hover:not(:disabled) {\n  border-color: #9ca3af;\n  transform: translateY(-0.4px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.refresh-types-btn:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n.refresh-types-btn:disabled {\n  border-color: #cbd5e1;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.refresh-types-btn.pc-refreshing {\n  border-color: #cbd5e1;\n  cursor: not-allowed;\n}\n\n/* Иконка обновления */\n.filter-select-wrapper .refresh-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.3s ease;\n}\n\n.filter-select-wrapper .refresh-icon.spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .filter-select-wrapper {\n    height: 32px;\n  }\n  \n  .filter-select-wrapper .filter-select {\n    min-width: 140px;\n    font-size: 13px;\n  }\n  \n  .filter-select-wrapper .refresh-types-btn {\n    width: 32px;\n  }\n  \n  .filter-select-wrapper .refresh-icon {\n    width: 14px;\n    height: 14px;\n  }\n}\n\n.filter-group-with-button {\n  display: flex;\n  align-items: center;\n}\n\n.filter-select-wrapper {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.filter-select-wrapper:focus-within {\n  border-color: #002FA7;\n  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);\n}\n\n.filter-select-wrapper .filter-select {\n  border: none;\n  border-radius: 8px 0 0 8px;\n  border-right: 1px solid #e2e8f0;\n  min-width: 160px;\n  height: 100%;\n  margin: 0;\n}\n\n.filter-select-wrapper .refresh-types-btn {\n  width: 36px;\n  height: 100%;\n  border: none;\n  border-radius: 0 8px 8px 0;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin: 0;\n}\n\n.filter-select-wrapper .refresh-types-btn:hover:not(:disabled) {\n  background: #e2e8f0;\n}\n\n.filter-select-wrapper .refresh-types-btn:disabled {\n  background: #f1f5f9;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.filter-select-wrapper .refresh-types-btn.refreshing {\n  background: #e2e8f0;\n}\n\n\n/* Новые стили для заголовков дат */\n.date-header-new {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 4px;\n}\n\n.date-info-btn {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: bold;\n  transition: all 0.2s ease;\n}\n\n.date-info-btn:hover {\n  color: #002FA7;\n  border-color: #002FA7;\n  transform: scale(1.05);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.date-title-new {\n  font-weight: 600;\n  color: #002c9c;\n  font-size: 14px;\n}\n\n.lesson-type-indicator {\n  font-size: 10px;\n  color: #666;\n  margin-top: 2px;\n  font-weight: 500;\n}\n\n/* Неактивные отчисленные/переведенные студенты в списке */\n\n.student-inactive {\n  background-color: #f8f9fa;\n}\n\n.student-inactive .cell-name {\n  color: #9ca3af;\n}\n\n.inactive-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 6px;\n  font-size: 10px;\n  background-color: #9c9c9c;\n  color: white;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.grade-cell.disabled,\n.exam-grade.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n/* Стили для модального окна информации о занятии (успеваемость) */\n.lesson-info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.lesson-info-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 95%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.lesson-info-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.lesson-info-modal-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.lesson-info-modal-close {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 20px;\n  cursor: pointer;\n  color: #64748b;\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.lesson-info-modal-close:hover {\n  background: #e2e8f0;\n  color: #374151;\n}\n\n.lesson-info-modal-content {\n  padding: 0;\n  background: white;\n}\n\n/* Детальная информация о занятии */\n.lesson-details-info {\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  overflow: hidden;\n}\n\n.info-section-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.info-section-content {\n  padding: 20px;\n}\n\n/* Сетка 4 колонки для информации о занятии */\n.info-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.info-grid-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px 12px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  text-align: center;\n  min-height: 70px;\n  justify-content: center;\n}\n\n.info-grid-label {\n  font-size: 11px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.info-grid-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n/* Секция управления занятием */\n.attendance-stats-section {\n  background: white;\n  overflow: hidden;\n}\n\n.attendance-stats-header {\n  background: #f8fafc;\n  color: #002FA7;\n  margin: 0;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.attendance-stats-content {\n  padding: 20px;\n}\n\n/* Стили для форм */\n.form-group-full-width {\n  margin-bottom: 20px;\n}\n\n.form-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.form-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background-color: white;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-input:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.form-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background-color: white;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n  cursor: text;\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-textarea:disabled {\n  background-color: #f9fafb;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.form-help-text {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 4px;\n}\n\n/* Кнопки действий */\n.lesson-info-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .lesson-info-modal {\n    width: 95%;\n    margin: 20px;\n    max-height: 95vh;\n  }\n  \n  .lesson-info-modal-header {\n    padding: 20px;\n  }\n  \n  .lesson-info-modal-header h3 {\n    font-size: 18px;\n  }\n  \n  .info-section-content,\n  .attendance-stats-content {\n    padding: 16px;\n  }\n  \n  .info-grid-4 {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n  \n  .info-grid-item {\n    padding: 14px 8px;\n    min-height: 65px;\n  }\n  \n  .info-grid-value {\n    font-size: 13px;\n  }\n  \n  .form-input,\n  .form-textarea {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .lesson-info-modal-header {\n    padding: 16px;\n  }\n  \n  .info-section-content,\n  .attendance-stats-content {\n    padding: 12px;\n  }\n  \n  .info-grid-4 {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .info-grid-item {\n    padding: 12px 8px;\n    min-height: 60px;\n  }\n  \n  .info-grid-label {\n    font-size: 10px;\n  }\n  \n  .info-grid-value {\n    font-size: 12px;\n  }\n  \n  .lesson-info-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .gradient-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Стили для управления датами */\n.date-management-actions {\n  margin-bottom: 15px;\n  display: flex;\n  gap: 10px;\n}\n\n.add-date-btn {\n  padding: 8px 16px;\n  font-size: 14px;\n}\n\n/* Стили для заголовков дат */\n.date-header-new {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-height: 60px;\n}\n\n/* Обновленные стили для заголовков дат */\n.date-header-new {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 4px;\n  min-height: 70px;\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  border-radius: 8px;\n  margin: 2px;\n  transition: all 0.3s ease;\n  border: 1px solid #f1f5f9;\n}\n\n.date-header-new:hover {\n  background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);\n  border-color: #e0e7ff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n/* Контейнер для кнопок */\n.date-header-actions {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 4px;\n  opacity: 1;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n  padding: 2px;\n  backdrop-filter: blur(4px);\n  z-index: 10;\n}\n\n/* Общие стили для кнопок*/\n.date-infos-btn, .date-delete-btn {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 4px;\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n/* Кнопка информации*/\n.date-infos-btn {\n  color: #64748b;\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  border-color: #cad2fe;\n}\n\n.date-infos-btn:hover {\n  color: #002FA7;\n  border-color: #002FA7;\n  background: linear-gradient(135deg, #f0f4ff 0%, #ffffff 100%);\n  transform: scale(1.1);\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.15);\n}\n\n/* Кнопка удаления  */\n.date-delete-btn {\n  color: #94a3b8;\n  background: linear-gradient(135deg, #fef2f2 0%, #ffffff 100%);\n  border-color: #fecaca;\n}\n\n.date-delete-btn:hover {\n  color: #dc2626;\n  border-color: #fca5a5;\n  background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);\n  transform: scale(1.1);\n  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.15);\n}\n\n/* Контент даты  */\n.date-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  margin-top: 24px;\n  width: 100%;\n}\n\n.date-title-new {\n  font-weight: 600;\n  color: #002c9c;\n  font-size: 14px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.lesson-type-indicator {\n  font-size: 10px;\n  color: #64748b;\n  padding: 2px 6px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Индикатор текущей даты */\n.date-header-new.current-date {\n  color: #64748b;\n  font-weight: 800;\n}\n\n.date-header-new.current-date .date-title-new {\n  color: #002FA7;\n  font-weight: 800;\n}\n\n.date-header-new.current-date .lesson-type-indicator {\n  background: #002FA7;\n  color: white;\n}\n\n/* Анимация появления */\n@keyframes dateHeaderAppear {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.date-header-new {\n  animation: dateHeaderAppear 0.3s ease-out;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .date-header-new {\n    min-height: 65px;\n    padding: 6px 3px;\n  }\n  \n  .date-header-actions {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.98);\n  }\n  \n  .date-info-btn, .date-delete-btn {\n    width: 20px;\n    height: 20px;\n    font-size: 11px;\n  }\n  \n  .date-title-new {\n    font-size: 12px;\n  }\n  \n  .lesson-type-indicator {\n    font-size: 9px;\n    padding: 1px 4px;\n  }\n  \n  .date-content {\n    margin-top: 20px;\n  }\n}\n\n/* Стили для пустых дат */\n.date-header-new.empty-date {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-color: #e2e8f0;\n}\n\n.date-header-new.empty-date .date-title-new {\n  color: #94a3b8;\n}\n\n/* Эффект при клике */\n.date-header-new:active {\n  transform: translateY(0);\n  transition: transform 0.1s ease;\n}\n\n/* Модальные окна для управления датами */\n.add-date-modal, .delete-date-modal {\n  max-width: 600px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.available-lessons-list h4 {\n  margin-bottom: 15px;\n  color: #002FA7;\n}\n\n.lessons-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 10px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.lesson-item {\n  padding: 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: white;\n}\n\n.lesson-item:hover {\n  border-color: #002FA7;\n  background: #f8f9ff;\n}\n\n.lesson-item.selected {\n  border-color: #002FA7;\n  background: #e6f0ff;\n}\n\n.lesson-date {\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 5px;\n  color: #002FA7;\n}\n\n.lesson-details {\n  font-size: 12px;\n  color: #666;\n}\n\n.lesson-day {\n  font-weight: 500;\n}\n\n.lesson-type, .lesson-pair {\n  margin-top: 2px;\n}\n\n.no-lessons-message {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.delete-confirmation {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.date-to-delete {\n  margin: 15px 0;\n  padding: 10px;\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.warning-text {\n  color: #dc3545;\n  font-size: 14px;\n  margin-top: 15px;\n}\n\n.delete-confirm-btn {\n  margin-top: 16px;\n  background: linear-gradient(135deg, #dc3545, #c82333);\n  color: white;\n  border: none;\n  height: 42px;\n  padding: 10px 28px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.delete-confirm-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #c82333, #bd2130);\n}\n\n.delete-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .lessons-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .date-management-actions {\n    flex-direction: column;\n  }\n  \n  .add-date-btn {\n    width: 100%;\n  }\n}\n\n/* Стили для пустого столбца добавления даты */\n.column-add-date {\n  width: 38px;\n  min-width: 38px;\n  background-color: transparent;\n  border-left: 1px solid #e2e8f0;\n  position: relative;\n  z-index: 5;\n}\n\n.add-date-column {\n  height: 30px;\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n  border: 1px dashed #cbd5e1;\n  border-radius: 6px;\n  margin: 2px;\n  position: relative;\n  overflow: hidden;\n}\n\n.add-date-column:hover {\n  background: white;\n  border-color: #002FA7;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 47, 167, 0.15);\n}\n\n.add-date-column::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(0, 47, 167, 0.05), transparent);\n  transition: left 0.3s;\n}\n\n.add-date-column:hover::before {\n  left: 100%;\n}\n\n.add-date-plus {\n  font-size: 20px;\n  font-weight: 600;\n  color: #64748b;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 2;\n}\n\n.add-date-column:hover .add-date-plus {\n  color: #002FA7;\n  transform: scale(1.05);\n}\n\n.add-date-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 40px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: white;\n  border: 1px dashed #cbd5e1;\n  border-radius: 6px;\n  margin: 1px;\n  position: relative;\n  overflow: hidden;\n}\n\n.add-date-cell:hover {\n  background: white;\n  border-color: #002FA7;\n  box-shadow: 0 1px 4px rgba(0, 47, 167, 0.1);\n}\n\n.add-date-cell::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(0, 47, 167, 0.03), transparent);\n  transition: left 0.3s;\n}\n\n.add-date-cell:hover::before {\n  left: 100%;\n}\n\n.add-date-cell-plus {\n  font-size: 16px;\n  font-weight: 600;\n  color: #64748b;\n  transition: all 0.2s ease;\n  position: relative;\n  z-index: 2;\n}\n\n.add-date-cell:hover .add-date-cell-plus {\n  color: #002FA7;\n}\n\n/* Анимация при клике */\n.add-date-column:active,\n.add-date-cell:active {\n  transform: translateY(0);\n  transition: transform 0.1s ease;\n  background: #f8fafc;\n}\n\n/* Состояние disabled */\n.add-date-column:disabled,\n.add-date-cell:disabled {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.add-date-column:disabled .add-date-plus,\n.add-date-cell:disabled .add-date-cell-plus {\n  color: #94a3b8;\n}\n\n.add-date-column:disabled:hover::before,\n.add-date-cell:disabled:hover::before {\n  left: -100%;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .column-add-date {\n    width: 45px;\n    min-width: 45px;\n  }\n  \n  .add-date-column {\n    min-height: 45px;\n    margin: 1px;\n  }\n  \n  .add-date-plus {\n    font-size: 18px;\n  }\n  \n  .add-date-cell {\n    min-height: 35px;\n  }\n  \n  .add-date-cell-plus {\n    font-size: 14px;\n  }\n}\n\n/* Стили для расширенного режима */\n.teacher-performance-section.expanded .column-add-date,\nbody.menu-collapsed .column-add-date {\n  width: 42px;\n  min-width: 42px;\n}\n\n.teacher-performance-section.expanded .add-date-column,\nbody.menu-collapsed .add-date-column {\n  height: 38px;\n  min-height: 38px;\n}\n\n.teacher-performance-section.expanded .add-date-cell,\nbody.menu-collapsed .add-date-cell {\n  min-height: 38px;\n}\n\n/* Интеграция с sticky колонками */\n.sticky-col-right {\n  position: sticky;\n  right: 0;\n  z-index: 10;\n}\n\n/* Убедитесь, что столбец добавления даты всегда виден при скролле */\n.performance-table-wrapper {\n  position: relative;\n}\n\n.column-add-date {\n  position: relative;\n  z-index: 5;\n}\n\n/* Состояние загрузки */\n.add-date-column.loading,\n.add-date-cell.loading {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.add-date-column.loading .add-date-plus,\n.add-date-cell.loading .add-date-cell-plus {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* Фокус состояния для доступности */\n.add-date-column:focus-visible,\n.add-date-cell:focus-visible {\n  outline: 2px solid #002FA7;\n  outline-offset: 1px;\n  border-color: #002FA7;\n}\n\n/* Улучшенная интеграция с таблицей */\n.performance-table th.column-add-date {\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.performance-table td.column-add-date {\n  background: white;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n/* Подсветка при наведении на строку */\n.performance-table tbody tr:hover td.column-add-date {\n  background: #f8fafc;\n}\n\n/* Расширенное модальное окно информации о занятии */\n.pc-modal.expanded {\n  max-width: 600px !important;\n  width: 95% !important;\n}\n\n/* Выравнивание ширины селектора типа занятия с полем темы */\n.pc-form-grid .pc-form-group.editable-field {\n  grid-column: 1 / -1;\n}\n\n.pc-form-grid .pc-form-group.editable-field select.pc-input {\n  width: 100%;\n}\n\n/* Убедимся, что все поля имеют одинаковую ширину */\n.pc-form-grid .pc-form-group .pc-input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Специфично для селектора типа занятия */\n.pc-form-group.editable-field select.pc-input {\n  width: 100% !important;\n  min-width: auto !important;\n}\n\n/* Адаптивность для расширенного модального окна */\n@media (max-width: 768px) {\n  .pc-modal.expanded {\n    width: 98% !important;\n    margin: 10px;\n  }\n}\n\n.pc-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.pc-input::placeholder {\n  color: #9ca3af;\n}\n\n/* Стили для select и textarea внутри .pc-input */\n.pc-input select,\n.pc-input textarea {\n  border: none;\n  outline: none;\n  width: 100%;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n}\n\n.pc-input textarea {\n  resize: vertical;\n  min-height: 80px;\n  line-height: 1.5;\n}\n\n.pc-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.pc-confirm-btn {\n  padding: 12px 32px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 140px;\n}\n\n.pc-confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.pc-confirm-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.pc-confirm-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .pc-modal {\n    width: 98%;\n    margin: 20px;\n  }\n  \n  .pc-form-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .pc-modal-content {\n    padding: 20px;\n  }\n}\n\n.type-filters {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-select {\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: left;\n  color: #1e293b;\n  background: white;\n  cursor: pointer;\n  width: 174px;\n  transition: all 0.2s ease;\n  height: 35px;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Контейнер таблицы */\n.performance-table-container {\n  width: 100%;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.performance-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  position: relative;\n}\n\n.performance-table {\n  min-width: 100%;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse;\n}\n\n/* При расширенном режиме увеличиваем ширину таблицы */\n.teacher-performance-section.expanded .performance-table,\nbody.menu-collapsed .performance-table {\n  min-width: 1200px;\n}\n\n.performance-table th {\n  background: white;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 16px 8px;\n  text-align: center;\n  border-bottom: 1px solid #e2e8f0;\n  user-select: none;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 30;\n}\n\n/* Выделенные колонки */\n.highlight-col {\n  background: #f0f4ff !important;\n}\n\n/* Стили для скрытия столбца подгрупп когда один преподаватель */\n.teacher-performance-section.no-subgroups .column-subgroup {\n  display: none;\n}\n\n.teacher-performance-section.no-subgroups .column-name {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n}\n\n/* Для мобильных устройств */\n@media (max-width: 768px) {\n  .teacher-performance-section.no-subgroups .column-name {\n    width: 200px;\n    min-width: 200px;\n    max-width: 200px;\n  }\n}\n\n/* Фиксированные заголовки */\n.performance-table th.column-number,\n.performance-table th.column-name,\n.performance-table th.column-subgroup,\n.performance-table th.column-average,\n.performance-table th.column-exam {\n  position: sticky;\n  z-index: 50;\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.performance-table th.column-number {\n  left: 0;\n  border-right: 2px solid #e2e8f0;\n}\n\n.performance-table th.column-name {\n  left: 60px;\n  border-right: 2px solid #e2e8f0;\n}\n\n.performance-table th.column-subgroup {\n  left: 310px;\n  border-right: 2px solid #e2e8f0;\n}\n\n.performance-table th.column-average {\n  right: 120px;\n  border-left: 2px solid #e2e8f0;\n}\n\n.performance-table th.column-exam {\n  right: 0;\n  border-left: 2px solid #e2e8f0;\n}\n\n.performance-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-align: center;\n  height: 70px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Фиксированные ячейки */\n.performance-table td.column-number,\n.performance-table td.column-name,\n.performance-table td.column-subgroup,\n.performance-table td.column-average,\n.performance-table td.column-exam {\n  position: sticky;\n  z-index: 40;\n  background: white;\n}\n\n.performance-table td.column-number {\n  left: 0;\n  border-right: 2px solid #e2e8f0;\n}\n\n.performance-table td.column-name {\n  left: 60px;\n  border-right: 2px solid #e2e8f0;\n  text-align: left !important;\n}\n\n.performance-table td.column-subgroup {\n  left: 310px;\n  border-right: 2px solid #e2e8f0;\n}\n\n.performance-table td.column-average {\n  right: 120px;\n  border-left: 2px solid #e2e8f0;\n}\n\n.performance-table td.column-exam {\n  right: 0;\n  border-left: 2px solid #e2e8f0;\n}\n\n/* Подсветка при наведении на строку */\n.performance-table tbody tr:hover td.column-number,\n.performance-table tbody tr:hover td.column-name,\n.performance-table tbody tr:hover td.column-subgroup,\n.performance-table tbody tr:hover td.column-average,\n.performance-table tbody tr:hover td.column-exam {\n  background: #f0f4ff;\n}\n\n/* Конкретные размеры и позиции колонок */\n.column-number {\n  width: 60px;\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.column-name {\n  width: 250px;\n  min-width: 250px;\n  max-width: 250px;\n  text-align: left;\n}\n\n.column-subgroup {\n  width: 100px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.column-date {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.column-average {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n.column-exam {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n/* При расширенном режиме увеличиваем ширину некоторых колонок */\n.teacher-performance-section.expanded .column-name,\nbody.menu-collapsed .column-name {\n  width: 300px;\n  min-width: 300px;\n  max-width: 300px;\n}\n\n.teacher-performance-section.expanded .column-date,\nbody.menu-collapsed .column-date {\n  width: 90px;\n  min-width: 90px;\n  max-width: 90px;\n}\n\n/* Стили для ячеек */\n.cell-number {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 14px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.cell-name {\n  text-align: left !important;\n  padding: 12px 16px !important;\n  font-weight: 500;\n  color: #1e293b;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cell-subgroup {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 13px;\n  text-align: center;\n}\n\n.subgroup-select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.subgroup-select:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n/* Контейнер ячейки с оценкой */\n.grade-cell-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  height: 100%;\n  justify-content: center;\n  padding: 4px 0;\n}\n\n/* Оценка */\n.grade-cell {\n  height: 36px;\n  width: 36px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: white !important;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n}\n\n/* Стили для текста оценок */\n.grade-value, .exam-grade-value, .average-grade {\n  color: white !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Размеры для разных оценок */\n\n.grade-cell.large {\n  width: 45px;\n  height: 45px;\n  font-size: 10px;\n  min-width: 45px;\n  min-height: 45px;\n}\n\n.grade-cell:hover {\n  transform: scale(1.15);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n/* Цвета для оценок */\n.grade-excellent {\n  background: #2cbb00;\n}\n\n.grade-good {\n  background: #a5db28;\n}\n\n.grade-satisfactory {\n  background: #f59e0b;\n}\n\n.grade-unsatisfactory {\n  background: #ef4444;\n}\n\n.grade-empty {\n  background: transparent;\n  border: 1px solid #cbd5e1;\n  color: #94a3b8 !important;\n  text-shadow: none;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.grade-empty:hover {\n  border-color: #002FA7;\n  color: #002FA7 !important;\n  background: #f0f4ff;\n}\n\n/* Стили для input при редактировании */\n.grade-input {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-weight: 400;\n  font-size: 13px;\n  color: #1e293b !important;\n  outline: none;\n}\n\n.grade-input::placeholder {\n  color: rgba(156, 156, 156, 0.7);\n  font-weight: 400;\n}\n\n/* Средний балл */\n.average-grade {\n  font-weight: 700;\n  font-size: 14px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  display: inline-block;\n  min-width: 60px;\n  text-align: center;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  border: 2px solid transparent;\n}\n\n/* Экзамен */\n.exam-cell-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.exam-grade {\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n  min-width: 40px;\n  min-height: 30px;\n}\n\n.exam-grade:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n/* Цвета для экзаменационных оценок */\n.exam-grade-excellent {\n  background: #2cbb00;\n}\n\n.exam-grade-good {\n  background: #a5db28;\n}\n\n.exam-grade-satisfactory {\n  background: #f59e0b;\n}\n\n.exam-grade-unsatisfactory {\n  background: #ef4444;\n}\n\n.exam-grade-pass {\n  background: #2cbb00;\n}\n\n.exam-grade-fail {\n  background: #ef4444;\n}\n\n.exam-grade-empty {\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  color: #94a3b8 !important;\n  text-shadow: none;\n  font-weight: 600;\n}\n\n.exam-grade-empty:hover {\n  border-color: #002FA7;\n  color: #002FA7 !important;\n  background: #f0f4ff;\n}\n\n.exam-grade-select {\n  width: 100%;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-weight: 700;\n  font-size: 13px;\n  color: #1e293b !important;\n  outline: none;\n  cursor: pointer;\n}\n\n.exam-grade-value {\n  padding: 2px 4px;\n}\n\n/* Модальные окна */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: white;\n  padding: 24px;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  min-width: 500px;\n  max-width: 600px;\n}\n\n.modal-content h3 {\n  margin: 0 0 16px 0;\n  color: #002FA7;\n  font-size: 18px;\n}\n\n.modal-content textarea {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.modal-content textarea:focus {\n  outline: none;\n  border-color: #002FA7;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.cancel-btn {\n  padding: 8px 16px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n  border-color: #64748b;\n  background: #f8fafc;\n}\n\n/* Стили для скроллбара */\n.performance-table-wrapper::-webkit-scrollbar {\n  height: 8px;\n}\n\n.performance-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.performance-table-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n.performance-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Стили для отображения типа аттестации в заголовке */\n.global-exam-header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  padding: 8px 4px;\n}\n\n.global-exam-header .exam-type-code {\n  font-size: 16px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.global-exam-header .exam-type-label {\n  font-size: 11px;\n  color: #64748b;\n}\n\n/* Когда аттестация не назначена */\n.column-exam.no-certification {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.column-exam.no-certification .global-exam-header {\n  color: #94a3b8;\n}\n\n/* Индикатор сохранения экзамена */\n.exam-saving-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 8px;\n}\n\n.exam-saving-spinner span {\n  font-size: 11px;\n  font-weight: 500;\n  color: white;\n}\n\n.loading-spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: exam-spin 0.8s linear infinite;\n}\n\n@keyframes exam-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Контейнер ячейки экзамена */\n.exam-cell-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  min-height: 90px;\n}\n\n.exam-grade {\n  cursor: pointer;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  transition: all 0.2s ease;\n  border: 2px solid transparent;\n  min-width: 90px;\n  width: 100%;\n}\n\n.exam-grade-value {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.retake-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: 11px;\n  cursor: pointer;\n  user-select: none;\n  padding: 4px 8px;\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.retake-checkbox-label:hover {\n  background: white;\n}\n\n.retake-checkbox {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.retake-label {\n  color: #1e293b;\n  font-weight: 500;\n  font-size: 11px;\n}\n\n.certification-none {\n  padding: 6px 10px;\n  background: #f1f5f9;\n  border-radius: 8px;\n  color: #64748b;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n.certification-error {\n  padding: 6px 10px;\n  background: #fef2f2;\n  border-radius: 8px;\n  color: #dc2626;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n/* Кнопка комментария */\n.comment-btn {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 4px;\n  color: #64748b;\n  transition: all 0.3s ease;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  position: relative;\n}\n\n/* Обновленные стили для комментариев */\n.comment-history-item {\n  padding: 16px;\n  background: white;\n  border-bottom: 1px solid #f1f5f9;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.comment-history-item:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 12px;\n}\n\n.comment-date {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.comment-author-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.teacher-badge {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.student-badge {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.comment-text {\n  font-size: 14px;\n  color: #1e293b;\n  line-height: 1.5;\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border-left: 3px solid #002FA7;\n}\n\n.comment-files {\n  margin-top: 12px;\n}\n\n.files-header {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.files-grid-compact {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 8px;\n}\n\n.file-item-preview-compact {\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.file-item-preview-compact:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.explorer-upload-btn {\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #002FA7 0%, #0f53ff 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.explorer-upload-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);\n  transform: translateY(-1px);\n}\n\n.explorer-upload-btn:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Стили для информации о форматах */\n.file-formats-info {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 8px;\n}\n\n/* Компактные стили для файлов */\n.file-preview {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  gap: 8px;\n}\n\n.file-info-compact {\n  flex: 1;\n  min-width: 0;\n}\n\n.file-name-compact {\n  font-size: 12px;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.file-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.file-link, .download-link {\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.file-link {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.file-link:hover {\n  background: #e5e7eb;\n}\n\n.download-link {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.download-link:hover {\n  background: #c7d2fe;\n}\n\n/* Индикатор файлов в кнопке комментария */\n.file-indicator {\n  font-size: 10px;\n  margin-left: 2px;\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .file-preview-modal {\n    max-width: 95vw;\n    max-height: 95vh;\n    margin: 10px;\n  }\n  \n  .file-preview-actions {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .files-grid-compact {\n    grid-template-columns: 1fr;\n  }\n}\n\n.download-btn-simple:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  position: relative;\n}\n\n.download-btn-simple:disabled::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 16px;\n  height: 16px;\n  margin: -8px 0 0 -8px;\n  border: 2px solid transparent;\n  border-top: 2px solid #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.file-item-simple {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  border: 1px solid #e1e5e9;\n  border-radius: 6px;\n  margin-bottom: 8px;\n  background: #f8f9fa;\n}\n\n.file-icon {\n  margin-right: 12px;\n  font-size: 18px;\n}\n\n.file-info-simple {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 1;\n}\n\n.file-name-simple {\n  font-size: 14px;\n  color: #333;\n  flex-grow: 1;\n  margin-right: 12px;\n}\n\n.download-btn-simple {\n  background: #002FA7;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: background-color 0.2s;\n}\n\n.download-btn-simple:hover:not(:disabled) {\n  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);\n  transform: translateY(-1px);\n}\n\n/* Стили для вкладок комментариев */\n\n/* Новые стили для вкладок на весь экран */\n.comment-tabs-fullwidth {\n  display: flex;\n  width: 100%;\n  border-bottom: 2px solid #e2e8f0;\n  margin-bottom: 20px;\n  background: #f8fafc;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n}\n\n.comment-tab-fullwidth {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 20px;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 600;\n  color: #64748b;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.comment-tab-fullwidth:hover {\n  background: #f1f5f9;\n  color: #002FA7;\n}\n\n.comment-tab-fullwidth.active {\n  background: white;\n  color: #002FA7;\n  border-bottom-color: #002FA7;\n  box-shadow: 0 -2px 8px rgba(0, 47, 167, 0.1);\n}\n\n.tab-title {\n  white-space: nowrap;\n}\n\n.tab-badge-fullwidth {\n  background: #002FA7;\n  color: white;\n  border-radius: 12px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 20px;\n  text-align: center;\n}\n\n.comment-tab-fullwidth.active .tab-badge-fullwidth {\n  background: white;\n  color: #002FA7;\n  border: 1px solid #002FA7;\n}\n\n.tab-content-fullwidth {\n  animation: fadeIn 0.3s ease;\n  min-height: 400px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n/* Простые стили для файлов */\n.file-item-simple {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background: white;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.file-item-simple:hover {\n  border-color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.15);\n  transform: translateY(-1px);\n}\n\n.file-info-simple {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  margin-left: 8px;\n}\n\n.file-name-simple {\n  font-size: 14px;\n  color: #374151;\n  flex: 1;\n}\n\n.download-btn-simple {\n  padding: 8px 16px;\n  background: linear-gradient(135deg, #002FA7 0%, #0f53ff 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 12px;\n  transition: all 0.2s ease;\n  font-weight: 600;\n}\n\n.download-btn-simple:hover {\n  background: linear-gradient(135deg, #001f7a 0%, #0a46e0 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(15, 83, 255, 0.3);\n}\n\n.file-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.comment-files-simple {\n  margin-top: 12px;\n}\n\n.files-header-simple {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.files-list-simple {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Стили для существующих файлов */\n.existing-files-section {\n  margin-top: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  background: #f8fafc;\n}\n\n.view-file-btn {\n  padding: 4px 8px;\n  background: #002FA7;\n  color: white;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.view-file-btn:hover {\n  background: #001f7a;\n  transform: translateY(-1px);\n}\n\n/* Расширенное модальное окно комментариев */\n.comment-modal.expanded {\n  max-width: 900px !important;\n  max-height: 95vh !important;\n  width: 95vw !important;\n  min-height: 600px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Увеличенные области контента */\n.comment-modal.expanded .comment-input-section {\n  flex-shrink: 0;\n  margin-bottom: 0;\n}\n\n.comment-modal.expanded .comment-textarea {\n  min-height: 100px;\n  font-size: 14px;\n}\n\n.comment-modal.expanded .comment-history-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.comment-modal.expanded .comment-history-list {\n  flex: 1;\n  max-height: none !important;\n  min-height: 160px;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .comment-tabs {\n    flex-direction: column;\n  }\n  \n  .comment-tab {\n    text-align: center;\n    border-bottom: 1px solid #e2e8f0;\n    border-left: 2px solid transparent;\n  }\n  \n  .comment-tab.active {\n    border-bottom-color: #e2e8f0;\n    border-left-color: #002FA7;\n  }\n}\n\n/* Стили для вкладок комментариев */\n.comment-tabs {\n  display: flex;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.comment-tab {\n  position: relative;\n  padding: 12px 24px;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.comment-tab:hover {\n  color: #002FA7;\n  background: #f8fafc;\n}\n\n.comment-tab.active {\n  color: #002FA7;\n  border-bottom-color: #002FA7;\n  background: #f0f4ff;\n}\n\n.tab-badge {\n  background: #002FA7;\n  color: white;\n  border-radius: 10px;\n  padding: 2px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* Стили для истории комментариев */\n.comment-history-section {\n  margin-top: 16px;\n}\n\n.comment-history-list {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.comment-history-item {\n  padding: 16px;\n  background: white;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.comment-history-item:last-child {\n  border-bottom: none;\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  gap: 12px;\n}\n\n.comment-date {\n  font-size: 12px;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n.comment-action {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  flex: 1;\n  text-align: right;\n}\n\n.comment-text {\n  font-size: 14px;\n  color: #1e293b;\n  line-height: 1.4;\n  margin-bottom: 12px;\n  padding: 12px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border-left: 3px solid #002FA7;\n}\n\n.comment-files {\n  margin-top: 12px;\n}\n\n.comment-divider {\n  height: 1px;\n  background: #e2e8f0;\n  margin: 8px 0;\n}\n\n/* Стили для состояний загрузки и пустых состояний */\n.loading-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  color: #64748b;\n  gap: 12px;\n}\n\n.loading-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-comments-section {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 2px dashed #e2e8f0;\n}\n\n/* Стили для секции ввода комментария преподавателя */\n.comment-input-section {\n  margin-bottom: 20px;\n  padding: 16px;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Расширенное модальное окно комментариев */\n.comment-modal.expanded {\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .comment-tabs {\n    flex-direction: column;\n  }\n  \n  .comment-tab {\n    text-align: center;\n    border-bottom: 1px solid #e2e8f0;\n    border-left: 2px solid transparent;\n    justify-content: center;\n  }\n  \n  .comment-tab.active {\n    border-bottom-color: #e2e8f0;\n    border-left-color: #002FA7;\n  }\n  \n  .comment-header {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .comment-action {\n    text-align: left;\n  }\n}\n\n.comment-btn.has-teacher-comment {\n  border-color: rgb(169, 171, 173);\n  color: #a7aab4;\n  box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);\n}\n\n.comment-btn.has-teacher-comment:hover {\n  background: #e1e2e6;\n  border-color: #a7aab4;\n  transform: scale(1.1);\n}\n\n.comment-btn.has-student-comment:hover {\n  background: #e0e6fe;\n  border-color: #1d4ed8;\n  transform: scale(1.1);\n}\n\n.comment-btn.has-student-comment {\n  border-color: #6088c9;\n  color: #1d4ed8;\n  box-shadow: 0 2px 4px rgba(168, 85, 247, 0.2);\n}\n\n.comment-btn.has-both-comments {\n  border-color: #f59e0b;\n  color: #d97706;\n  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);\n}\n\n/* Для комментария к оценке */\n.comment-modal {\n  max-width: 600px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  padding: 24px;\n}\n\n.comment-textarea-container {\n  position: relative;\n}\n\n.comment-textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  resize: vertical;\n  font-family: inherit;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  min-height: 100px;\n}\n\n.comment-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.attached-files-section {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 16px;\n  background: #f8fafc;\n  margin-top: 8px;\n}\n\n.files-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.files-header span {\n  font-weight: 600;\n  color: #374151;\n  font-size: 14px;\n}\n\n.files-instruction {\n  font-size: 12px;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 8px 12px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  border-left: 3px solid #3b82f6;\n}\n\n.files-list {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: white;\n}\n\n.file-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  background: white;\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.file-item:hover {\n  background: #f8fafc;\n}\n\n.file-item:last-child {\n  border-bottom: none;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.file-icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 12px;\n  color: #64748b;\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n.file-name {\n  font-size: 13px;\n  color: #374151;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-size {\n  font-size: 12px;\n  color: #64748b;\n  margin-left: 8px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.file-preview {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  object-fit: cover;\n  margin-right: 12px;\n  border: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.remove-file-btn {\n  background: transparent;\n  color: #64748b;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.remove-file-btn:hover {\n  background: #ef4444;\n  color: white;\n  border-color: #ef4444;\n  transform: scale(1.05);\n}\n\n/* Стили для скроллбара */\n.files-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.files-list::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.files-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.files-list::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Состояние когда файлов нет */\n.no-files-placeholder {\n  text-align: center;\n  padding: 30px 20px;\n  color: #64748b;\n  font-size: 13px;\n  background: white;\n  border-radius: 6px;\n  border: 2px dashed #e2e8f0;\n  background: #fafafa;\n}\n\n.file-type-badge {\n  background: #f1f5f9;\n  color: #475569;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  margin-left: 8px;\n  font-weight: 500;\n}\n\n/* Превью изображений */\n.image-preview-container {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Стили для состояния ошибки */\n.error-state {\n  text-align: center;\n  padding: 60px 40px;\n  color: #ef4444;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  margin: 20px 0;\n}\n\n.error-message {\n  font-size: 16px;\n  margin-bottom: 24px;\n  line-height: 1.5;\n  color: #1e293b;\n}\n\n.error-message strong {\n  color: #ef4444;\n  font-weight: 600;\n}\n\n/* Стили для кнопки \"Повторить попытку\" */\n.retry-button {\n  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);\n  border: 2px solid rgba(239, 68, 68, 0.3);\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n}\n\n.retry-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.3);\n  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);\n}\n\n.retry-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2);\n}\n\n.retry-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\n}\n\n/* Анимация для кнопки при наведении */\n.retry-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.5s;\n}\n\n.retry-button:hover::before {\n  left: 100%;\n}\n\n/* Иконка обновления */\n.retry-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.3s ease;\n}\n\n.retry-button:hover .retry-icon {\n  transform: rotate(180deg);\n}\n\n/* Стили для иконки ошибки */\n.error-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  color: #ef4444;\n  opacity: 0.8;\n}\n\n/* Блок среднего балла группы */\n.group-average-footer {\n  padding: 16px 14px;\n  background: transparent;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.group-average-percentage {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 16px;\n  background: white;\n  border-radius: 50px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.average-circle {\n  width: 62px;\n  height: 62px;  \n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: conic-gradient(\n    var(--average-color, #ffffff) 0% var(--average, 0%),\n    #f1f5f9 var(--average, 0%) 100%\n  );\n}\n\n.average-circle::before {\n  content: '';\n  position: absolute;\n  width: 52px;\n  height: 52px;\n  background: white;\n  border-radius: 50%;\n  align-items: center;\n}\n\n.average-value {\n  font-size: 15px; \n  font-weight: 800;\n  z-index: 1;\n  color: var(--average-color, #ffffff);\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.average-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  padding-right: 5px;\n}\n\n/* Стили для заголовка таблицы с rowspan */\n.table-header-rowspan {\n  vertical-align: middle;\n  text-align: center;\n}\n\n/* Стили для отображения преподавателя в фильтрах */\n\n.teacher-value-readonly {\n  font-size: 14px;\n  color: #002FA7;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n/* Модальное окно подгрупп с th- префиксом */\n.th-subgroup-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(50, 64, 124, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.th-subgroup-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  width: 95%;\n  max-width: 700px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  animation: th-modal-appear 0.2s ease-out;\n}\n\n@keyframes th-modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.th-subgroup-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 24px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border-radius: 12px 12px 0 0;\n  color: white;\n}\n\n.th-subgroup-modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: white;\n}\n\n.th-subgroup-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  padding: 4px 8px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.th-subgroup-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n}\n\n.th-subgroup-modal-content {\n  padding: 24px;\n}\n\n.th-subgroup-stats {\n  display: flex;\n  justify-content: center;\n  gap: 40px;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.th-subgroup-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 24px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  min-width: 120px;\n}\n\n.th-stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n.th-stat-label {\n  font-size: 14px;\n  color: #64748b;\n  font-weight: 500;\n  text-align: center;\n}\n\n.th-auto-distribute-section {\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.th-auto-distribute-btn {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 180px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.th-auto-distribute-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.th-auto-distribute-btn:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.th-students-section {\n  margin-bottom: 24px;\n}\n\n.th-students-section h4 {\n  margin: 0 0 12px 0;\n  color: #002FA7;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.th-students-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.th-student-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.th-student-item:hover {\n  border-color: #002FA7;\n  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.1);\n}\n\n.th-student-name {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.th-subgroup-select {\n  width: 140px;\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.th-subgroup-select:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 2px rgba(0, 47, 167, 0.1);\n}\n\n.th-subgroup-select:disabled {\n  background: #f1f5f9;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.th-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.th-cancel-btn {\n  padding: 10px 20px;\n  border: 2px solid #e2e8f0;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  color: #64748b;\n  transition: all 0.2s ease;\n  min-width: 120px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.th-cancel-btn:hover:not(:disabled) {\n  border-color: #64748b;\n  background: #f8fafc;\n  transform: translateY(-1px);\n}\n\n.th-cancel-btn:disabled {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #9ca3af;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.th-save-btn {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 180px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.th-save-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.3);\n}\n\n.th-save-btn:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.th-save-btn.th-loading {\n  position: relative;\n  color: transparent;\n  pointer-events: none;\n}\n\n.th-save-btn.th-loading::after {\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  top: 50%;\n  left: 50%;\n  margin: -10px 0 0 -10px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: th-button-spin 0.8s linear infinite;\n}\n\n@keyframes th-button-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .th-subgroup-modal {\n    width: 98%;\n    max-height: 95vh;\n  }\n  \n  .th-subgroup-stats {\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n  }\n  \n  .th-subgroup-stat {\n    flex-direction: row;\n    justify-content: space-between;\n    min-width: auto;\n  }\n  \n  .th-auto-distribute-btn {\n    width: 100%;\n  }\n  \n  .th-student-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .th-subgroup-select {\n    width: 100%;\n  }\n  \n  .th-modal-actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .th-cancel-btn,\n  .th-save-btn {\n    width: 100%;\n  }\n}\n\n/* Стили для заголовка с кнопками информации и обновления */\n.performance-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.header-left-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Стили для кнопок в заголовке */\n.header-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n}\n\n.header-btn:hover {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-color: #94a3b8;\n  transform: translateY(-1px);\n}\n\n.header-btn:active {\n  transform: translateY(0);\n}\n\n/* Стили для сетки оценок */\n.grades-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.grades-row {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.grade-demo {\n  width: 34px;\n  height: 34px;\n  border-radius: 6px;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n\n/* Цвета для оценок */\n.grade-excellent {\n  background: #2cbb00;\n}\n\n.grade-good {\n  background: #a5db28;\n}\n\n.grade-satisfactory {\n  background: #f59e0b;\n}\n\n.grade-unsatisfactory {\n  background: #ef4444;\n}\n\n.grades-note {\n  margin-top: 10px;\n  text-align: center;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.grades-note code {\n  background: #f1f5f9;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 11px;\n  color: #002FA7;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n}\n\n@media (max-width: 480px) {\n  .info-tooltip {\n    width: 95vw;\n    padding: 12px;\n    left: 0;\n    transform: translateY(8px);\n    margin-left: 0;\n  }\n  \n  .info-tooltip::before {\n    left: 20px;\n  }\n  \n  .info-tooltip-content {\n    font-size: 13px;\n  }\n}\n\n@keyframes pc-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Стили для кнопки обновления */\n.pc-refresh-btn {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.pc-refresh-btn.pc-refreshing {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.pc-refresh-icon {\n  width: 18px;\n  height: 18px;\n  transition: all 0.3s ease;\n  filter: brightness(0.8);\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  filter: brightness(1);\n}\n\n@keyframes pc-spin {\n  0% { \n    transform: rotate(0deg);\n    filter: brightness(0.8);\n  }\n  50% {\n    filter: brightness(1.2);\n  }\n  100% { \n    transform: rotate(360deg);\n    filter: brightness(0.8);\n  }\n}\n\n/* Эффект пульсации для кнопки во время обновления */\n.pc-refresh-btn.pc-refreshing::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.4),\n    transparent\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .performance-cabinet-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .header-btn {\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .info-tooltip {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    min-width: 280px;\n    max-width: 90vw;\n  }\n  \n  .info-icon-btn:hover .info-tooltip {\n    opacity: 0;\n    visibility: hidden;\n  }\n  \n  .info-icon-btn:focus .info-tooltip,\n  .info-icon-btn:active .info-tooltip {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-btn {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n  \n  .info-tooltip-content {\n    padding: 12px;\n    font-size: 12px;\n  }\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .subgroup-stats {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .student-subgroup-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .subgroup-select-modal {\n    width: 100%;\n  }\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .teacher-performance-section {\n    width: 100%;\n    min-width: 100%;\n    padding: 12px;\n  }\n  \n  .teacher-performance-section.expanded,\n  body.menu-collapsed .teacher-performance-section {\n    width: 100% !important;\n  }\n  \n  .performance-filters {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .performance-title-container {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .performance-actions {\n    justify-content: space-between;\n    width: 100%;\n  }\n  \n  .modal-content {\n    min-width: 90vw;\n    margin: 20px;\n  }\n  \n  .column-name {\n    width: 200px;\n    min-width: 200px;\n  }\n  \n  .column-number {\n    width: 50px;\n    min-width: 50px;\n  }\n  \n  .column-subgroup {\n    width: 80px;\n    min-width: 80px;\n  }\n  \n  .grade-cell {\n    min-width: 35px;\n    min-height: 25px;\n    font-size: 12px;\n  }\n\n  .error-state {\n    padding: 40px 20px;\n    margin: 16px 0;\n  }\n  \n  .error-message {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n  \n  .retry-button {\n    padding: 10px 20px;\n    font-size: 13px;\n    min-width: 140px;\n  }\n\n  /* Принудительное исправление курсоров */\n.pc-modal .pc-input {\n  cursor: pointer !important;\n}\n\n.pc-modal .pc-input:read-only {\n  cursor: not-allowed !important;\n}\n\n.pc-modal .pc-input[readonly] {\n  cursor: not-allowed !important;\n}\n\n.pc-modal textarea.pc-input {\n  cursor: text !important;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
